import React from 'react';
import Body from './Body';
import Head from './Head';

const Table = ({
  as: Components,
  sortIcon,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("table", props, /*#__PURE__*/React.createElement(Head, {
    sortIcon: sortIcon
  }), /*#__PURE__*/React.createElement(Body, {
    as: Components
  }));
};

export default Table;